import React from "react";
import UnifiedFormComponent from "./components/UnifiedFormComponent";

const LaporanLayar = () => {
  const handleSuccess = (result) => {
    console.log('Layar data saved successfully:', result);
  };

  const handleError = (error) => {
    console.error('Error saving Layar data:', error);
  };

  return (
    <UnifiedFormComponent 
      formType="layar"
      onSuccess={handleSuccess}
      onError={handleError}
    />
  );
};

export default LaporanLayar;
